"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationSessionReducer = exports.initialState = exports.TransmitActionType = void 0;
var AllyTransmitUIHandler_1 = require("./AllyTransmitUIHandler");
var TransmitActionType;
(function (TransmitActionType) {
    TransmitActionType[TransmitActionType["UpdateScreen"] = 0] = "UpdateScreen";
    TransmitActionType[TransmitActionType["UpdateScreenError"] = 1] = "UpdateScreenError";
    TransmitActionType[TransmitActionType["AuthenticateUser"] = 2] = "AuthenticateUser";
    TransmitActionType[TransmitActionType["NavigateToEntryScreen"] = 3] = "NavigateToEntryScreen";
    TransmitActionType[TransmitActionType["StartRehydration"] = 4] = "StartRehydration";
    TransmitActionType[TransmitActionType["RehydrationFailure"] = 5] = "RehydrationFailure";
    TransmitActionType[TransmitActionType["SetDeviceData"] = 6] = "SetDeviceData";
    TransmitActionType[TransmitActionType["HandleRequest"] = 7] = "HandleRequest";
    TransmitActionType[TransmitActionType["HandleFailure"] = 8] = "HandleFailure";
    TransmitActionType[TransmitActionType["StartPolicy"] = 9] = "StartPolicy";
    TransmitActionType[TransmitActionType["HandleRedirect"] = 10] = "HandleRedirect";
    TransmitActionType[TransmitActionType["AuthenticateUserWithTicket"] = 11] = "AuthenticateUserWithTicket";
    TransmitActionType[TransmitActionType["CreateLegacySession"] = 12] = "CreateLegacySession";
    TransmitActionType[TransmitActionType["CreateCenlarSSO"] = 13] = "CreateCenlarSSO";
    TransmitActionType[TransmitActionType["ResetStatus"] = 14] = "ResetStatus";
})(TransmitActionType = exports.TransmitActionType || (exports.TransmitActionType = {}));
var accountForForgotPasswordErrors = function (_a) {
    var oldScreen = _a.oldScreen, newScreen = _a.newScreen;
    if (newScreen.type === 'ForgotPassword' &&
        oldScreen.type === 'ResetPassword') {
        return __assign(__assign({}, newScreen), { type: oldScreen.type });
    }
    return newScreen;
};
exports.initialState = {
    activeScreen: { type: 'Unauthenticated' },
    sessionStatus: { status: 'Unauthenticated' },
    deviceData: null,
};
var AuthenticationSessionReducer = function (state, action) {
    switch (action.type) {
        case TransmitActionType.UpdateScreen:
            return __assign(__assign({}, state), { activeScreen: accountForForgotPasswordErrors({
                    oldScreen: state.activeScreen,
                    newScreen: action.payload,
                }), sessionStatus: { status: 'Authenticating' } });
        case TransmitActionType.UpdateScreenError:
            return __assign(__assign({}, state), { activeScreen: __assign(__assign({}, state.activeScreen), { payload: __assign(__assign({}, state.activeScreen.payload), action.payload.payload) }) });
        case TransmitActionType.AuthenticateUser:
            return __assign(__assign({}, state), { activeScreen: {
                    type: 'Authenticated',
                    payload: action.payload,
                }, sessionStatus: {
                    status: 'Authenticated',
                    data: action.payload,
                } });
        case TransmitActionType.AuthenticateUserWithTicket:
            return __assign(__assign({}, state), { activeScreen: {
                    type: 'AuthenticatedWithTicket',
                    payload: action.payload,
                }, sessionStatus: {
                    status: 'AuthenticatedWithTicket',
                    ticketID: action.payload,
                } });
        case TransmitActionType.CreateLegacySession:
            return __assign(__assign({}, state), { sessionStatus: {
                    status: 'LegacyAuthenticated',
                    data: action.payload,
                } });
        case TransmitActionType.CreateCenlarSSO:
            return __assign(__assign({}, state), { sessionStatus: {
                    status: 'CenlarSSOAuthenticated',
                    data: action.payload,
                } });
        case TransmitActionType.StartRehydration:
            return __assign(__assign({}, state), { sessionStatus: { status: 'Rehydrating' } });
        case TransmitActionType.HandleRedirect:
            return __assign(__assign({}, state), { sessionStatus: { status: 'Redirecting' } });
        case TransmitActionType.RehydrationFailure: {
            return __assign(__assign({}, state), { sessionStatus: { status: 'RehydrationFailed' } });
        }
        case TransmitActionType.HandleRequest: {
            var currentScreen = state.activeScreen;
            // Typescript doesn't like combining these...
            switch (currentScreen.type) {
                case AllyTransmitUIHandler_1.InformationScreenType.PasswordUpdated:
                case AllyTransmitUIHandler_1.InformationScreenType.OBSA:
                case AllyTransmitUIHandler_1.InformationScreenType.ESign:
                case AllyTransmitUIHandler_1.InformationScreenType.SetupWelcome:
                case 'RegisterDevice':
                case 'SetupComplete':
                case 'SetupSecurity':
                case 'VerifyCode':
                case 'NewPassword':
                case 'SendCode':
                case 'Password':
                case 'ForgotPassword':
                case 'ResetPassword':
                case 'RecoveryOptions':
                case 'VerifyCustomerInfo':
                case 'Enroll':
                case 'EnrollCredentialCreation':
                case 'EnrollConfirmation':
                case 'GuestCredentialCreation':
                case 'GuestConsent':
                case 'GuestConfirmation':
                case 'ForgotUsername':
                case 'SelectAccount':
                case 'ConfirmSSN':
                case 'ForgotUsernameConfirmation':
                    return __assign(__assign({}, state), { activeScreen: {
                            type: currentScreen.type,
                            payload: __assign(__assign({}, currentScreen.payload), { status: 'Loading' }),
                        } });
                default:
                    return state;
            }
        }
        case TransmitActionType.NavigateToEntryScreen: {
            var oldScreenType = state.activeScreen.type;
            var newScreenType = action.payload.entryScreenType;
            var newScreenPayload = action.payload.entryScreenPayload || {};
            if (oldScreenType === newScreenType ||
                state.sessionStatus.status === 'Redirecting' ||
                oldScreenType === 'Authenticated') {
                return state;
            }
            return __assign(__assign({}, state), { activeScreen: {
                    type: newScreenType,
                    payload: __assign({ status: 'None' }, newScreenPayload),
                } });
        }
        case TransmitActionType.SetDeviceData:
            return __assign(__assign({}, state), { deviceData: action.payload });
        case TransmitActionType.HandleFailure:
            return __assign(__assign({}, state), { activeScreen: {
                    type: 'TemporarilyUnavailable',
                    payload: { error: 'Default' },
                }, sessionStatus: { status: 'AuthenticationFailed' } });
        case TransmitActionType.ResetStatus:
            // Resets payload status to 'None' from 'Loading'. This is needed to let the UI
            // know that a dispatched action has completed and not returned one of the expected
            // payload types
            return __assign(__assign({}, state), { activeScreen: __assign(__assign({}, state.activeScreen), { payload: __assign(__assign({}, state.activeScreen.payload), { status: 'None' }) }) });
        default:
            return state;
    }
};
exports.AuthenticationSessionReducer = AuthenticationSessionReducer;
//# sourceMappingURL=reducer.js.map